import React, { Component, PropTypes } from 'react';
import ReactDOM from 'react-dom';
import shouldPureComponentUpdate from 'react-pure-render/function';

import Tag from 'components/Tag/Tag';

import './SearchUnitDestination.scss';

export default class SearchUnitDestination extends Component {
  static propTypes = {
    selectedElements: PropTypes.array,
    allOptions: PropTypes.array,
    onInputChange: PropTypes.func.isRequired,
    onRemove: PropTypes.func,
    isDisabled: PropTypes.bool,
    placeholder: PropTypes.string,
    labelStyle: PropTypes.string,
    onPageChange: PropTypes.func,
    type: PropTypes.string,
    queryValue: PropTypes.string,
    addAnotherPlaceholder: PropTypes.string,
    reportSearchFieldClicked: PropTypes.func,
    hasNoResults: PropTypes.bool,
    onClick: PropTypes.func,
    onKeyDown: PropTypes.func.isRequired,
    onBlur: PropTypes.func,
    isEverywhereEnabled: PropTypes.bool,
  };

  static defaultProps = {
    addAnotherPlaceholder: 'Add another',
    hasNoResults: true,
    isEverywhereEnabled: false,
    labelStyle: 'panda',
    placeholder: 'Any',
    queryValue: '',
    selectedElements: [],
    type: 'fix',
  };

  shouldComponentUpdate = shouldPureComponentUpdate;

  saveComponentRef = ref => this.linkRef = ref;

  onInputChange = (event) => {
    const { onInputChange } = this.props;

    onInputChange(event, ReactDOM.findDOMNode(this.linkRef));
  }

  get placeholder() {
    const { selectedElements } = this.props;
    return selectedElements.length ? '+ Add another' : 'Search e.g. Spain, Eden Resort';
  }

  handleOnBlur = (event) => {
    const { onBlur } = this.props;
    if (onBlur) {
      onBlur(event);
    }
  }

  handleOnClick = (event) => {
    const { onClick, reportSearchFieldClicked } = this.props;

    if (reportSearchFieldClicked) {
      reportSearchFieldClicked(event);
    }

    if (onClick) {
      onClick(event, ReactDOM.findDOMNode(this.linkRef));
    }
  }

  render() {
    const {
      addAnotherPlaceholder,
      hasNoResults,
      isDisabled,
      onKeyDown,
      onRemove,
      queryValue,
      selectedElements,
    } = this.props;

    const isFlex = this.props.type === 'flex';

    return (
      <div onClick={this.handleOnClick} className="search-unit-destination" ref={this.saveComponentRef}>
        <label className="search-unit-destination__label">
          Destination(s) or Hotel:
        </label>
        <div
          className={`search-unit-destination__inner ${isDisabled ? 'search-unit-destination__inner--is-disabled' : ''} ${isFlex ? 'search-unit-destination__inner--is-flex' : ''}`}
        >
          { !!selectedElements.length && (
            <div className={`search-unit-destination__inner__list-wrapper${isFlex ? ' search-unit-destination__inner__list-wrapper--is-flex' : ''}`}>
              <ul className={`search-unit-destination__inner__list ${isFlex ? 'search-unit-destination__inner__list--is-flex' : ''}`}>
                {
                  selectedElements.map((element = {}, index) => element.label && (
                    <li
                      key={index}
                      className={`search-unit-destination__inner__list__el${isFlex ? ' search-unit-destination__inner__list__el--is-flex' : ''}`}
                    >
                      <Tag id={element.dimValId || element.id} onRemove={onRemove}>
                        {element.label}
                      </Tag>
                    </li>
                  ))
                }
                { isFlex && (
                  <li className="search-unit-destination__inner__list__el search-unit-destination__inner__list__el--is-placeholder">
                    { addAnotherPlaceholder }
                  </li>
                )}
              </ul>
            </div>
          )}

          <input
            type="text"
            onChange={this.onInputChange}
            className="search-unit-destination__input"
            placeholder={this.placeholder}
            value={queryValue}
            onKeyDown={onKeyDown}
            onBlur={this.handleOnBlur}
          />
          { hasNoResults && (
            <div className="search-unit-destination__inner__no-results">No matches found</div>
          )}
        </div>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/SearchUnitDestination/SearchUnitDestination.jsx
 **/